import { get } from "lodash-es";
import { postDrafts } from "../../apis/drafts";
import { getApprobalListByParam } from "../../utils/approval";

const getTask = async ({ mode, defaultData }) => {
  const getTitle = (form) => {
    return "문서 발급 요청";
  };

  const fields = [
    {
      title: "제목",
      key: "title",
      type: "input",
      required: true,
    },
    {
      title: "발급요청내용",
      key: "content",
      type: "textarea",
      placeholder: 'ex) 현금영수증 발급 요청드립니다.',
      required: true,
    },
    {
      title: "첨부파일",
      key: "uploadFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
  ];

  const defaultForm = {
    title: get(defaultData, 'data.draft.title', getTitle()),
    content: get(defaultData, 'data.draft.content', ""),
    uploadFiles: get(defaultData, 'data.draft.uploadFiles', []),
  };

  const create = (form) => {

    const params = {
      title: form.title,
      content: form.content,
      type: "issue_request",
      uploadFiles: form.uploadFiles,
      approvals: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
    };

    return postDrafts(params);
  };
  const validate = (form) => {
    let errors = {};
    return errors;
  };
  return {
    fields, defaultForm, create, validate
  };
};

export default getTask;